import { gql } from "@apollo/client";

const PET_FIELDS = gql`
  fragment PetFields on PetWithAge {
    id
    name
    image
    isWellnessplan
    species
  }
`;

const CARD_DETAILS_FIELDS = gql`
  fragment CardDetailsFields on Card {
    id
    cardBrand
    cardType
    last4
    expMonth
    expYear
    isDefault
    hasSubscription
    cardholderName
    customerId
    expiryStatus
    isActive
  }
`;

const WELLNESS_PLAN_FIELDS = gql`
  fragment WellnessPlanFields on WellnessPlanObject {
    billingInterval
    price
    wellnessplanName
    planType
  }
`;

const EZYVET_INVOICE_FIELDS = gql`
  fragment EzyvetInvoiceFields on CancelWellnessInvoice {
    id
  }
`;

const SQUARE_INVOICE_FIELDS = gql`
  fragment SquareInvoiceFields on SquareInvoices {
    publicUrl
    amount
    status
    dueDate
  }
`;

const WELLNESS_PLAN_DETAILS_FIELDS = gql`
  fragment WellnessPlanDetailsFields on WellnessPlanDetails {
    status
    startDate
    endDate
    nextBillingDate
    wellnessId
    nextRenewal
    renewalStatus
    isAutoRenewal
    cardDetails {
      ...CardDetailsFields
    }
  }
  ${CARD_DETAILS_FIELDS}
`;

const FETCH_WELLNESS_PLANS_FOR_USERS = gql`
  fragment fetchWellnessPlansData on FetchWellnessPlansForUsers {
    subscriptionId
    planName
    planId
    isScratchpay
    isOverdue
    pet {
      ...PetFields
    }
    wellnessPlanDetails {
      ...WellnessPlanDetailsFields
    }
    wellnessPlan {
      ...WellnessPlanFields
    }
    wellnessPlanPaymentStatus
    pendingEzyvetInvoices {
      ...EzyvetInvoiceFields
    }
    pendingSquareInvoices {
      ...SquareInvoiceFields
    }
  }
  ${PET_FIELDS}
  ${WELLNESS_PLAN_DETAILS_FIELDS}
  ${WELLNESS_PLAN_FIELDS}
  ${EZYVET_INVOICE_FIELDS}
  ${SQUARE_INVOICE_FIELDS}
`;

const WELLNESS_PLANS_BY_USER = gql`
  ${FETCH_WELLNESS_PLANS_FOR_USERS}
  query getWellnessPlansForUser {
    getWellnessPlansForUser {
      recentlyCancelWellnessPlanByUser {
        ...fetchWellnessPlansData
      }
      wellnessPlanByUser {
        ...fetchWellnessPlansData
      }
    }
  }
`;

export default WELLNESS_PLANS_BY_USER;
